import React from 'react';

import { Text } from '../atom/Text';
import { FindForm } from '../organism/FindForm';
import PageTemplate from './PageTemplate';

import { ERROR_VALIDATE, ERROR_VALIDATE_ORDER } from '../../../lib/Error';

const FindTemplate = ({
  findEmailState,
  onFindEmail,
  onChangeFindEmailValue,
  findEmailRef,
  isFindEmailValidateTrue,
  findPasswordState,
  onFindPassword,
  FindPasswordRef,
  onChangeFindPasswordValue,
  isFindPasswordValidateTrue,
}) => {
  return (
    <PageTemplate title={SUB_HEADER_TITLE}>
      <FindForm
        formData={FIND_ID_DATA}
        onClickButton={onFindEmail}
        onChangeValue={onChangeFindEmailValue}
        state={findEmailState}
        isComplete={findEmailState.findId}
        inputRef={findEmailRef}
        isValidateTrue={isFindEmailValidateTrue}
      >
        회원님의 계정 아이디는{' '}
        <Text style={{ color: '#5699ff' }}>{findEmailState.id}</Text>
        입니다.
      </FindForm>
      <FindForm
        formData={FIND_PASSWORD_DATA}
        onClickButton={onFindPassword}
        onChangeValue={onChangeFindPasswordValue}
        state={findPasswordState}
        isComplete={findPasswordState.findPassword}
        inputRef={FindPasswordRef}
        isValidateTrue={isFindPasswordValidateTrue}
      >
        가입하신 이메일로 비밀번호 변경 링크를 보내드렸습니다.
      </FindForm>
    </PageTemplate>
  );
};

export default React.memo(FindTemplate);

const SUB_HEADER_TITLE = '아이디/비밀번호 찾기';

const FIND_ID_DATA = {
  title: '아이디 찾기',
  data: [
    {
      label: '아이디 찾기',
      type: 'text',
      name: 'name',
      mainIconName: 'person',
      placeholder: '이름을 입력해주세요.',
      errorMessage: ERROR_VALIDATE.name,
    },
    {
      label: null,
      type: 'tel',
      name: 'mobile',
      mainIconName: 'smartphone',
      placeholder: '휴대폰 번호를 입력해주세요.',
      errorMessage: ERROR_VALIDATE_ORDER.mobile,
    },
  ],
};

const FIND_PASSWORD_DATA = {
  title: '비밀번호 찾기',
  data: [
    {
      label: '비밀번호 찾기',
      type: 'text',
      name: 'name',
      mainIconName: 'person',
      placeholder: '이름을 입력해주세요.',
      errorMessage: ERROR_VALIDATE.name,
    },
    {
      label: null,
      type: 'email',
      name: 'email',
      mainIconName: 'email',
      placeholder: '이메일 주소를 입력해주세요.',
      errorMessage: ERROR_VALIDATE.email,
    },
  ],
};
